// import { i18nReducer } from 'redux-react-i18n';
import { combineReducers } from 'redux';
import AuthReducer from './auth-reducer';
import ContactReducer from './contact-reducer';
import AccountListReducer from './accountList-reducer';
import LoaderReducer from './loader-reducer';
import ToastNotificationReducer from './ToastNotificationReducer';
import PostReducer from './urt-reducer';
import PassengerRducer from './passenger-reducer';
import JetCardReducer from './jetcard-reducer';
import GlobalSearchReducer from './globalSearch-reducer';
import { RESET_LOGIN_USER_DATA } from '@/constant/redux-const';
import TripReducer from './trip-reducer';
import formikDataReducer from './formik-data-reducer';
import formikManageTripReducer from '../formik/trip-reducer';
import NotificationReducer from './notification-reducer';
import OperatorReducer from './operator-reducer';
import AircraftReducer from './aircraft-reducer';
import AirportReducer from './airport-reducer';
import FboReducer from './fbo.reducer';
import OperatorMDReducer from './operatorMD-reducer';
import TripReportsReducer from './tripReports-reducer';
import FlightReducer from './flight-reducer';

/** Add Multiple Reducer */
const reducers = {
  commonReducer: LoaderReducer,
  posts: PostReducer,
  loader:LoaderReducer,
  toast: ToastNotificationReducer,
  contacts:ContactReducer,
  accountList: AccountListReducer,
  auth: AuthReducer,
  passenger:PassengerRducer,
  jetCard: JetCardReducer,
  trip: TripReducer,
  tripReports: TripReportsReducer,
  globalSearch: GlobalSearchReducer,
  formikData: formikDataReducer,
  formikManageTrip: formikManageTripReducer,
  notification: NotificationReducer,
  operator: OperatorReducer,
  aircraft: AircraftReducer,
  airport:AirportReducer,
  fbo:FboReducer,
  operatorMD: OperatorMDReducer,
  flight: FlightReducer,
};

const rootReducer = combineReducers(reducers);

export type RootState = ReturnType<typeof rootReducer>;

export default (state: any, action: any) => rootReducer(action.type === RESET_LOGIN_USER_DATA ? undefined : state, action);
